import { number_to_human, number_to_currency, number_to_percentage, number_to_human_size } from 'number_helpers';

export const countryByISO = countryISO => ({ WW: 'Worldwide', ...COUNTRIES_ARRAY })[countryISO];
export const getValidStore = store => (store === 'unified' || store === 'unified') ? 'itunes_connect' : store;

export const numberToHuman = (number, config = {}) => number_to_human(number || 0, {
  precision: 2,
  space_label: false,
  strip_insignificant_zeros: true,
  labels: { thousand: 'K', million: 'M', billion: 'B' },
  ...config,
});

export const numberToCurrency = (number, config = {}) => number_to_currency(number || 0, {
  precision: 2,
  strip_insignificant_zeros: true,
  ...config,
});

export const numberToSize = (number, config = {}) => number_to_human_size(number || 0, {
  precision: 2,
  strip_insignificant_zeros: true,
  ...config,
});
